/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Meta_TitleInputs */

const en_login_page_meta_title = /** @type {(inputs: Login_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in | Glider`)
};

const de_login_page_meta_title = /** @type {(inputs: Login_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden | Glider`)
};

const pt_br2_login_page_meta_title = /** @type {(inputs: Login_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar | Glider`)
};

const tr_login_page_meta_title = /** @type {(inputs: Login_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giriş yap | Glider`)
};

const zh_cn2_login_page_meta_title = /** @type {(inputs: Login_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录 | Glider`)
};

const zh_hk2_login_page_meta_title = /** @type {(inputs: Login_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入 | Glider`)
};

const ko_kr2_login_page_meta_title = /** @type {(inputs: Login_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인 | Glider`)
};

const ru_ru2_login_page_meta_title = /** @type {(inputs: Login_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти | Glider`)
};

const es_419_login_page_meta_title = /** @type {(inputs: Login_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión | Glider`)
};

/**
* | output |
* | --- |
* | "Sign in \| Glider" |
*
* @param {Login_Page_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_meta_title = /** @type {((inputs?: Login_Page_Meta_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Meta_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_meta_title(inputs)
	if (locale === "de") return de_login_page_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_meta_title(inputs)
	if (locale === "tr") return tr_login_page_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_meta_title(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_meta_title(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_meta_title(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_meta_title(inputs)
	return es_419_login_page_meta_title(inputs)
});